import {
  AlertCircle,
  BookOpen,
  Brain,
  Cpu,
  FlaskConical,
  FolderOpen,
  GitBranch,
  Info,
  Key,
  ListChecks,
  MonitorPlay,
  Play,
  SlidersHorizontal,
  TestTube2,
  Users,
  Wand2,
  Zap,
} from "lucide-react";

export const BLOCK_ICONS = {
  Brain,
  MonitorPlay,
  ListChecks,
  FlaskConical,
  SlidersHorizontal,
  Zap,
  Users,
  FolderOpen,
  GitBranch,
  TestTube2,
  BookOpen,
  Play,
  Cpu,
  Key,
  AlertCircle,
  Info,
  Wand2,
};

export function resolveBlockIcon(iconKey) {
  return BLOCK_ICONS[iconKey] ?? BookOpen;
}
